export default __webpack_public_path__ + "static/media/Page1.e2154e8c.txt";